import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import { setGroup } from "../redux/actions";
import { GAME_TIME_SECS, ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import "./StartGame.css";
import "./SessionEndPages.css";

function Gameover() {
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const group = useSelector((state) => state.group);
	const game = useSelector((state) => state.game);

	useEffect(() => {
		if (group) {
			dispatch(
				setGroup({
					...group,
					lastVisited: ROUTES.RESULTS,
					finished: true,
				})
			);
			updateStats({
				...group,
				lastVisited: ROUTES.RESULTS,
				finished: true,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- sincronizar cierre una vez al montar
	}, []);

	const handleClick = (e) => {
		e.preventDefault();
		if (loading) return;
		setLoading(true);
		getGameById(game?._id)
			.then((res) => {
				if (res.status === 200) {
					navigate(ROUTES.RESULTS);
				} else {
					setLoading(false);
				}
			})
			.catch(() => {
				navigate(ROUTES.RESULTS);
			});
	};

	return (
		<div className="start-game-page session-end-page session-end-page--timeout">
			<div className="start-game-inner start-game-inner--prep5 session-end-inner">
				<span className="start-game-badge sg5-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Tiempo de juego
				</span>

				<div className="sg5-scroll session-timeout-scroll">
					<header className="sg5-hero session-gameover-hero">
						<h1 className="sg5-title">
							<span className="sg5-title-accent">Se acabó el tiempo</span>
						</h1>
						<p className="sg5-lead session-end-lead">
							El límite de {Math.floor(GAME_TIME_SECS / 60)} minutos para esta partida ha finalizado.
							Podéis consultar el resultado con la puntuación y el tiempo acumulados hasta ahora.
						</p>
					</header>
				</div>

				<div className="sg5-actions session-gameover-actions">
					<button
						type="button"
						className="start-game-cta sg5-cta session-end-cta-wide"
						onClick={handleClick}
						disabled={loading}
						aria-busy={loading}
					>
						{loading ? <span className="start-game-cta-spinner" aria-hidden /> : null}
						{loading ? "…" : "Ver resultados"}
					</button>
				</div>
			</div>
		</div>
	);
}

export default Gameover;
